import { initGrid } from 'utils/grid/grid';
import { fetchRecipients } from 'message/actions/recipients.actions';
import template from './recipients-list.html';

const mapStateToThis = ({
  session, messages, ui, config,
}) => {
  const { locale, isAdmin } = session;
  const { recipients, recipientsLoadingStatus: isLoading } = messages;
  const { pagination } = ui;
  const {
    defaultPageSizes, sortColumnKey, pageSizeKey, directionKey,
  } = config;

  return {
    recipients,
    locale,
    isLoading,
    pagination,
    pageSizeKey,
    sortColumnKey,
    directionKey,
    isAdmin,
    defaultPageSize: defaultPageSizes[2],
  };
};

const mapDispatchToThis = {
  fetchRecipients,
};

// eslint-disable-next-line no-undef
@Inject('messageDefinitionService', '$ngRedux')
class RecipientsListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.headers = this.getHeaders();
    this.defaultParams = {
      [this.sortColumnKey]: 'userName',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSize,
    };
    this.gridModel = initGrid(this.fetchRecipients, this.defaultParams);

    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  search() {
    this.gridModel.pagingModel.filters = {
      ...this.gridModel.pagingModel.filters,
      sentMessageId: this.resolve.sentMessageId,
    };
    this.gridModel.applyFilters();
  }

  getHeaders() {
    let headers = [
      {
        text: this.messageDefinitionService.get('USERNAME', 'desc'),
        field: 'userName',
        sortable: false,
      },
      {
        text: this.messageDefinitionService.get('READ_STATUS', 'desc'),
        field: 'isRead',
        sortable: false,
        textAlignment: 'text-right',
      },
      {
        text: this.messageDefinitionService.get('READ_DATE', 'desc'),
        field: 'readDate',
        sortable: false,
        textAlignment: 'text-right',
      },
    ];
    if (this.isAdmin) {
      headers = [
        ...headers,
        {
          text: this.messageDefinitionService.get('REPLIED_STATUS', 'desc'),
          field: 'isReplied',
          sortable: false,
          textAlignment: 'text-right',
        },
        {
          text: this.messageDefinitionService.get('REPLIED_DATE', 'desc'),
          field: 'repliedDate',
          sortable: false,
          textAlignment: 'text-right',
        },
      ];
    }
    return headers;
  }

  isChecked(id) {
    return this.selectedMessagesList.includes(id);
  }
}

export default class RecipientsListComponent {
  constructor() {
    this.controller = RecipientsListController;
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/recipients-list/recipients-list-component.js